import {
  CONNECTION_STATUS,
  DOWNLOAD_FILE,
  GET_JURISDICTIONS_SUCCESS,
  GET_JURISDICTIONS_FAILURE,
  GET_SPECIALRATEPROVISIONS_SUCCESS,
  GET_SPECIALRATEPROVISIONS_CLEAR,
  OPEN_ABOUT,
  CLOSE_ABOUT,
  API_STATUS,
  GET_IGACOMBOS_SUCCESS,
  GET_IGACOMBOS_FAILURE,
  GET_STOCKMARKETS_SUCCESS,
  GET_STOCKMARKETS_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function common(state = {
  jurisdictions: null,
  specialRateProvisions: null,
  isAboutOpen: false,
  apiStatus: null
}, action) {
  switch (action.type) {
    case CONNECTION_STATUS:
      return {
        ...state,
        connectionInfo: action.connectionInfo,
        isOnline: action.isOnline,
        retries: action.retries
      };
    case DOWNLOAD_FILE:
      return {
        ...state,
        downloadedFilename: action.downloadedFilename
      };
    case GET_JURISDICTIONS_SUCCESS:
      return {
        ...state,
        jurisdictions: action.jurisdictions
      };
    case GET_JURISDICTIONS_FAILURE:
      return {
        ...state,
        jurisdictions: null
      };
    case GET_SPECIALRATEPROVISIONS_SUCCESS:
      return {
        ...state,
        specialRateProvisions: action.specialRateProvisions
      };
    case GET_SPECIALRATEPROVISIONS_CLEAR:
      return {
        ...state,
        specialRateProvisions: null
      };
    case OPEN_ABOUT:
      return {
        ...state,
        isAboutOpen: true
      };
    case CLOSE_ABOUT:
      return {
        ...state,
        isAboutOpen: false
      };
    case API_STATUS:
      return {
        ...state,
        apiStatus: action.apiStatus
      };
    case GET_IGACOMBOS_SUCCESS:
      return {
        ...state,
        igaSubClassificationsCombos: action.igaSubClassificationsCombos
      };
    case GET_IGACOMBOS_FAILURE:
      return {
        ...state,
        igaSubClassificationsCombos: null
      };
    case GET_STOCKMARKETS_SUCCESS:
      return {
        ...state,
        stockMarkets: action.stockMarkets
      };
    case GET_STOCKMARKETS_FAILURE:
      return {
        ...state,
        stockMarkets: null
      };
    default:
      return state;
  }
}

export default common;
